// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"TmapFromData_ModalBody__3OG-i"};